import { useContentfulContext } from "../../../contexts/ContentfulContext";

export default function Card({
    images,
    imageAlt,
    title,
    onClick,
    isNoPreviewType,
    isDisabled = false,
}) {
    const { content } = useContentfulContext();
    return (
        <div
            className={`relative group bg-white border shadow-xl transition-all duration-300 transform 
                ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer hover:-translate-y-1 hover:scale-105 hover:shadow-xl'}`}
            onClick={isDisabled ? undefined : onClick}
        >
            {/* Hover text for disabled cards */}
            {isDisabled && (
                <div className="absolute text-black inset-0 bg-white bg-opacity-50 z-10 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity duration-200 p-4 text-center text-md font-bold">
                    {content.CHOOSE_TEMPLATE_CONTENT.not_accessable}
                </div>
            )}
            {isNoPreviewType ? (
                <div className="flex bg-[#4b5563cb] w-full max-w-5xl h-[250px]">
                    <div className=" bg-white w-full p-4 flex flex-col items-center justify-center ">
                        <img
                            className="object-contain h-full "
                            src={images?.mobile_only || content.CHOOSE_TEMPLATE_CONTENT.no_preview_available_image_url}
                            alt={imageAlt || ""}
                        />
                    </div>
                </div>
            ) : (
                <div className="flex gap-1 bg-[white] w-full max-w-5xl h-[250px]">
                    <div className="border-r bg-white w-[30%] flex flex-col items-center justify-center">
                        <img
                            className="object-contain h-full "
                            src={images?.mobile_only || content.CHOOSE_TEMPLATE_CONTENT.no_image_available_image_url}
                            alt={imageAlt || ""}
                        />
                    </div>

                    <div className="bg-white w-[70%] flex flex-col items-center justify-center">
                        <img
                            className="object-contain h-full"
                            src={images?.web_only || content.CHOOSE_TEMPLATE_CONTENT.no_image_available_image_url}
                            alt={imageAlt || ""}
                        />
                    </div>
                </div>
            )}
            <div className="p-3 border-t text-center flex content-center items-center flex-col justify-center">
                <h5
                    className="text-md font-bold tracking-tight max-w-full truncate"
                    title={title}
                >
                    {title}
                </h5>
            </div>
        </div>
    );
}
